module.exports = __webpack_public_path__ + "img/intro_uk.70ac37f1.svg";